/* Server-rendered prices, exact line keys, and a native form if JS is unavailable. */
(() => {
  function init(root) {
    if (!root || root.dataset.enhanced || !window.fetch || !window.AbortController) return;
    const content = root.querySelector('[data-rr-cart-content]');
    const status = root.querySelector('[data-rr-cart-status]');
    const error = root.querySelector('[data-rr-cart-error]');
    const errorText = root.querySelector('[data-rr-cart-error-text]');
    if (!content || !status || !error || !errorText) return;
    root.dataset.enhanced = 'true';
    root.classList.add('rr-cart-enhanced');
    let pending = null, timer = null, busy = false, uncertain = false;
    const inputs = () => [...content.querySelectorAll('[data-rr-cart-input]')];
    const valid = input => input.value.trim() !== '' && Number.isSafeInteger(Number(input.value)) && Number(input.value) >= 0 && input.checkValidity();
    const controls = () => {
      const invalid = inputs().some(input => !valid(input));
      content.querySelectorAll('[name=checkout]').forEach(button => { button.disabled = busy || uncertain || !!pending || invalid; });
      inputs().forEach(input => { input.disabled = busy || uncertain; });
      content.querySelectorAll('[data-rr-cart-remove]').forEach(link => link.setAttribute('aria-disabled', String(busy || uncertain)));
      content.setAttribute('aria-busy', String(busy));
    };
    async function request(url, options) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try { return await fetch(url, {credentials:'same-origin', ...options, signal:controller.signal}); }
      finally { clearTimeout(timeout); }
    }
    function render(html, focus) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-rr-cart-content]');
      if (!fresh || !/^\d+$/.test(fresh.dataset.cartCount || '')) throw new Error(root.dataset.error);
      content.innerHTML = fresh.innerHTML;
      content.dataset.cartCount = fresh.dataset.cartCount;
      document.querySelectorAll('[data-rr-bag-count]').forEach(el => { el.textContent = fresh.dataset.cartCount; });
      document.querySelectorAll('[data-rr-bag-link]').forEach(el => el.setAttribute('aria-label', root.dataset.bagLabel.replace('__COUNT__', fresh.dataset.cartCount)));
      document.dispatchEvent(new CustomEvent('rr:cart-updated'));
      // Discount changes may change line keys. The returned row order is authoritative.
      const rows = [...content.querySelectorAll('[data-rr-line-key]')];
      const row = rows[Math.min(focus.index, rows.length - 1)];
      const target = row?.querySelector(focus.remove ? '[data-rr-cart-remove]' : '[data-rr-cart-input]') || root.querySelector('h1');
      target?.focus({preventScroll:true});
    }
    async function refresh(focus) {
      const url = new URL(root.dataset.cartUrl, location.origin);
      url.search = location.search;
      url.searchParams.set('section_id', root.dataset.sectionId);
      const response = await request(url.href, {cache:'no-store', headers:{Accept:'text/html'}});
      if (!response.ok) throw new Error(root.dataset.error);
      render(await response.text(), focus);
    }
    async function flush() {
      clearTimeout(timer);
      if (busy || uncertain || !pending) return;
      const change = pending;
      pending = null;
      busy = true;
      error.hidden = true;
      status.textContent = root.dataset.updating;
      controls();
      let received = false;
      try {
        const response = await request(root.dataset.changeUrl, {
          method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({id:change.key, quantity:change.quantity, sections:[root.dataset.sectionId], sections_url:location.pathname + location.search})
        });
        received = true;
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
        const html = result.sections?.[root.dataset.sectionId];
        if (html) render(html, change); else await refresh(change);
        status.textContent = root.dataset.updated;
      } catch (failure) {
        // A failed response can still accompany a changed cart. Never retry the POST.
        uncertain = true;
        if (received) {
          try { await refresh(change); uncertain = false; } catch { /* Require a fresh page before checkout. */ }
        }
        status.textContent = '';
        error.hidden = false;
        errorText.textContent = uncertain ? root.dataset.error : failure.message;
      } finally { busy = false; controls(); }
    }
    function queue(input, immediate = false, remove = false) {
      if (busy || uncertain) return;
      clearTimeout(timer);
      const row = input.closest('[data-rr-line-key]');
      if (!row) return;
      if (!valid(input)) {
        pending = null;
        input.setAttribute('aria-invalid', 'true');
        status.textContent = root.dataset.invalid;
        controls();
        return;
      }
      input.removeAttribute('aria-invalid');
      const quantity = Number(input.value);
      if (quantity === Number(row.dataset.rrCartQuantity)) {
        pending = null; status.textContent = ''; controls(); return;
      }
      pending = {key:row.dataset.rrLineKey, quantity, remove, index:[...content.querySelectorAll('[data-rr-line-key]')].indexOf(row)};
      status.textContent = root.dataset.updating;
      controls();
      if (immediate) flush(); else timer = setTimeout(flush, 350);
    }
    root.addEventListener('input', event => { if (event.target.matches('[data-rr-cart-input]')) queue(event.target); });
    root.addEventListener('change', event => { if (event.target.matches('[data-rr-cart-input]')) queue(event.target, true); });
    root.addEventListener('click', event => {
      const remove = event.target.closest('[data-rr-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      if (busy || uncertain) return;
      const input = remove.closest('[data-rr-line-key]').querySelector('[data-rr-cart-input]');
      input.value = '0'; queue(input, true, true);
    });
    root.addEventListener('submit', event => {
      if (busy || uncertain || pending || inputs().some(input => !valid(input))) { event.preventDefault(); flush(); }
    });
    controls();
  }
  const start = () => document.querySelectorAll('[data-rr-cart]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
